import { authenticatedFetch } from './auth-context.js';

/**
 * Download a file from an authenticated API endpoint (e.g. /v1/.../export).
 * Fetches with the bearer token, then saves the blob via a temporary link.
 */
export async function downloadFromApi(path: string, fallbackFilename: string): Promise<void> {
  const res = await authenticatedFetch(path);
  if (!res.ok) throw new Error(`Export failed: ${res.statusText}`);
  const blob = await res.blob();
  const disposition = res.headers.get('Content-Disposition') ?? '';
  const match = /filename="?([^";]+)"?/.exec(disposition);
  const filename = match?.[1] ?? fallbackFilename;
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}
